import styled, { css } from 'styled-components'
import { assetPrefix } from 'config/env_config'
import { MEDIA } from 'utils/constants'
import { Button as StyledButton } from 'components/button/v2'

const backgroundModalBodyDesktop = `${assetPrefix}/static/images/backgrounds/bg-therm-petanjo-desktop.jpg`
const backgroundModalBodyMobile = `${assetPrefix}/static/images/backgrounds/bg-therm-petanjo-mobile.jpg`
const closeIcon = `${assetPrefix}/static/icons/times.svg`
const headerBackground = `${assetPrefix}/static/images/cobasi-petanjo-novo.png`

const catIcon = `${assetPrefix}/static/icons/cat-green.svg`
const dogIcon = `${assetPrefix}/static/icons/dog-orange.svg`

export const Container = styled.div`
    ${({ show }) => css`
        position: fixed;
        top: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        z-index: ${show ? 999 : -1};
        opacity: ${show ? 1 : 0};
        visibility: ${show ? 'visible' : 'hidden'};
        transition: 0.3s;

        @media screen and ${MEDIA.MOBILE} {
            overflow: auto;
        }
    `}
`

export const Backdrop = styled.div`
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    z-index: 1;
    background-color: rgba(0,0,0,0.2);
`

export const ModalContent = styled.div`
    width: 100%;

    overflow: hidden;
    border-radius: 2.4rem;

    max-width: 580px;
    background-image: url('${backgroundModalBodyDesktop}');
    background-repeat: no-repeat;
    background-size: cover;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 24px;

    @media screen and ${MEDIA.MOBILE} {
        background-image: url('${backgroundModalBodyMobile}');

        top: 0;
        left: 0;
        transform: none;
        border-radius: 0;
    }
`

export const ModalHeader = styled.div`
    width: 100%;
    height: 85px;
    padding: 16px;

    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    background-image: url('${headerBackground}');
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 15px;

    @media screen and ${MEDIA.MOBILE} {
        background-size: 80%;
    }
`

export const ModalBody = styled.div`
    background-color: var(--the-white);
    width: 85%;
    height: 80%;
    border-radius: 0 12px;

    padding: 25px;

    position: relative;

    @media screen and ${MEDIA.MOBILE} {
        width: 90%;
    }

    :before, :after {
        content: '';
        position: absolute;
    }

    :before {
        background-image: url('${catIcon}');
        background-size: cover;
        background-repeat: no-repeat;

        width: 56px;
        height: 85px;

        bottom: 20px;
        left: -37px;

        @media screen and ${MEDIA.MOBILE} {
            display: none;
        }
    }

    :after {
        background-image: url('${dogIcon}');
        background-size: cover;
        background-repeat: no-repeat;

        width: 75px;
        height: 70px;

        top: -3px;
        right: -38px;

        @media screen and ${MEDIA.MOBILE} {
            top: 17px;
            right: -32px;

            width: 54px;
            height: 46px;
        }
    }
`

export const ModalClose = styled.div`
    cursor: pointer;
    width: 24px;
    height: 24px;

    background-image: url('${closeIcon}');
    background-size: cover;
    background-repeat: no-repeat;
`

export const Paragraph = styled.p`
    font-size: 14px;
    font-family: var(--primary-font);
    margin-bottom: 15px;
    word-break: break-word;
    color: var(--gray-5);
`

export const Actions = styled.div`
    display: flex;
    justify-content: center;
    gap: 13px;
    width: 80%;
    margin: 0 auto;

    @media screen and ${MEDIA.MOBILE} {
        width: 100%;
        flex-direction: column-reverse;
    }
`

export const Button = styled(StyledButton)`
    @media screen and ${MEDIA.DESKTOP_UP} {
        width: 50%;
    }
`
